// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PortfolioPage CSS */

/* ── 자동 재집계 배너 ─────────────────────────────────────── */
.pf-reclose-banner {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
}

.pf-reclose-banner.checking {
  background: #e3f2fd;
  color: #1565c0;
  border: 1px solid #90caf9;
}

.pf-reclose-banner.done {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
}

/* ── 전체 레이아웃 ─────────────────────────────────────────── */
.pf-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e8eaed;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.pf-acct-btns {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  flex: 1 1;
}

.pf-acct-btn {
  padding: 5px 14px;
  border: 1px solid #d0d5dd;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
  color: #444;
  transition: all 0.15s;
}

.pf-acct-btn:hover   { border-color: #aaa; background: #f5f5f5; }
.pf-acct-btn.active  { background: #1565c0; border-color: #1565c0; color: #fff; font-weight: 600; }

.pf-diagnose-btn {
  padding: 5px 12px;
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #555;
  white-space: nowrap;
}

.pf-diagnose-btn:hover { background: #fff8e1; border-color: #f57c00; color: #e65100; }

.pf-reclose-btn {
  padding: 5px 14px;
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #555;
  white-space: nowrap;
}

.pf-reclose-btn:hover { background: #f0f4f8; border-color: #1565c0; color: #1565c0; }


/* ── 새로고침 버튼 ──────────────────────────────────────────── */
.pf-refresh-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #2e7d32;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s;
  line-height: 1;
}

.pf-refresh-btn:hover:not(:disabled) { background: #388e3c; }
.pf-refresh-btn:disabled             { opacity: 0.6; cursor: default; }
.pf-refresh-btn.spinning             { animation: pf-spin 0.8s linear infinite; }

@keyframes pf-spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}


/* ── 섹션 ──────────────────────────────────────────────────── */
.pf-section {
  background: #fff;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 8px;
}

.pf-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.pf-section-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: #1565c0;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.pf-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
}

.pf-temp-badge {
  font-size: 11px;
  color: #e65100;
  background: #fff3e0;
  border: 1px solid #ffcc80;
  border-radius: 12px;
  padding: 2px 8px;
}


/* ── 4카드 (Section ①) ────────────────────────────────────── */
.pf-cards-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 10px;
}

.pf-card {
  background: #f8f9fc;
  border: 1px solid #e5e9f0;
  border-radius: 8px;
  padding: 16px 18px;
  min-width: 0;
}

/* 라벨(좌측, 작게) + 큰 숫자(그 뒤, 카드 중간 지점 부근부터).
   금액 font-size가 커진 만큼 라벨 예약폭은 46%→36%로 줄여 금액이 잘리지 않도록 함 */
.pf-card-top {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.pf-card-label {
  font-size: 11.5px;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 36%;
}

.pf-card-value {
  flex: 1 1;
  min-width: 0;
  font-size: 2.6rem;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

/* 소제목 + 상세금액을 한 줄로 통합 - 커진 금액 글씨와 분리되도록 여백 확대 */
.pf-card-detail {
  font-size: 11.5px;
  color: #888;
  margin-top: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pf-card-value.pos { color: #c62828; }
.pf-card-value.neg { color: #1565c0; }
.pf-card-value.neu { color: #555; }


/* ── 보유 종목 헤더 ─────────────────────────────────────────── */
.pf-holdings-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.pf-sub-title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.pf-detail-btn {
  padding: 5px 14px;
  background: #f0f4ff;
  border: 1px solid #b3c8f0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #1565c0;
  font-weight: 500;
  white-space: nowrap;
}

.pf-detail-btn:hover { background: #e0ecff; border-color: #1565c0; }


/* ── 보유 종목 테이블 ────────────────────────────────────────── */
.pf-tbl-wrap {
  overflow-x: auto;
  border-radius: 6px;
  border: 1px solid #e5e9f0;
}

.pf-tbl {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}

.pf-tbl th {
  background: #f0f2f6;
  padding: 8px 10px;
  text-align: center;
  font-weight: 600;
  color: #444;
  border-bottom: 2px solid #d6dae6;
  white-space: nowrap;
}

.pf-tbl td {
  padding: 7px 10px;
  border-bottom: 1px solid #f0f2f5;
  white-space: nowrap;
}

.pf-tbl tr:last-child td { border-bottom: none; }
.pf-tbl tr:hover td { background: #fafbfe; }
.pf-tbl .num { text-align: right; }
.pf-tbl .pos { color: #c62828; }
.pf-tbl .neg { color: #1565c0; }
.pf-tbl .neu { color: #888; }


/* ── 기간 선택 바 ────────────────────────────────────────────── */
.pf-period-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 7px 12px;
  background: #fff;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.pf-period-btns {
  display: flex;
  gap: 4px;
}

.pf-p-btn {
  padding: 6px 16px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
  color: #444;
  transition: all 0.15s;
}

.pf-p-btn:hover  { background: #f5f5f5; border-color: #aaa; }
.pf-p-btn.active { background: #1565c0; border-color: #1565c0; color: #fff; font-weight: 600; }

.pf-nav-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pf-nav-btn {
  width: 30px;
  height: 30px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
}

.pf-nav-btn:hover    { background: #f0f4f8; border-color: #aaa; }
.pf-nav-btn:disabled { opacity: 0.4; cursor: default; }

.pf-nav-label {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  min-width: 110px;
  text-align: center;
}

.pf-custom-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pf-custom-sel {
  padding: 5px 10px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  font-size: 13px;
  color: #333;
  background: #fff;
  cursor: pointer;
}

.pf-custom-tilde { font-size: 14px; color: #666; }

.pf-custom-query-btn {
  padding: 6px 16px;
  background: #1565c0;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}

.pf-custom-query-btn:disabled { opacity: 0.5; cursor: default; }
.pf-custom-query-btn:hover:not(:disabled) { background: #1976d2; }


/* ── Section ② 기간 손익 ──────────────────────────────────── */
.pf-period-4cards-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.pf-period-op {
  font-size: 1.4rem;
  color: #555;
  font-weight: 300;
  flex-shrink: 0;
  line-height: 1;
}

.pf-period-card {
  flex: 1 1;
  background: #f8f9fc;
  border: 1px solid #e5e9f0;
  border-radius: 8px;
  padding: 16px 18px;
  min-width: 0;
}

.pf-period-card-total {
  background: #e8f0fe;
  border-color: #b8cef8;
}

.pf-period-card-total.pos { background: #fff0f0; border-color: #f5b8b8; }
.pf-period-card-total.neg { background: #f0f4ff; border-color: #b8c8f8; }

/* 매매손익(중간 합계) - 최종 합계(pf-period-card-total)보다는 약하게,
   그냥 카드(pf-period-card)보다는 눈에 띄게 구분 */
.pf-period-card-subtotal {
  background: #f3f5fa;
  border: 1.5px dashed #c3cce0;
}

/* 라벨(좌측, 작게) + 큰 숫자(그 뒤, 카드 중간 지점 부근부터).
   5개 카드가 +/= 기호와 한 줄을 나눠 쓰는 만큼 pf-card보다 폭이 좁아서
   라벨 예약폭을 줄여 커진 금액 글씨가 잘리지 않게 함 */
.pf-period-card-top {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.pf-period-card-label {
  font-size: 11.5px;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 32%;
}

.pf-period-card-value {
  flex: 1 1;
  min-width: 0;
  font-size: 2.6rem;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

/* 5카드(②기간별 손익)는 4카드보다 한 장 더 들어가 폭이 좁아지므로
   패딩/라벨폭/글씨크기를 줄여 1920px에서 줄바꿈·잘림 없이 한 줄에 들어오게 함 */
.pf-period-5cards-row {
  gap: 5px;
}

.pf-period-5cards-row .pf-period-op {
  font-size: 1.2rem;
}

.pf-period-5cards-row .pf-period-card {
  padding: 14px 12px;
}

.pf-period-5cards-row .pf-period-card-label {
  min-width: 26%;
}

.pf-period-5cards-row .pf-period-card-value {
  font-size: 2.2rem;
}

/* 노트북 등 좁은 화면(1600px 이하)에서는 한 번 더 줄여 잘림 방지 */
@media (max-width: 1600px) {
  .pf-period-5cards-row .pf-period-card        { padding: 12px 10px; }
  .pf-period-5cards-row .pf-period-card-label  { font-size: 10.5px; min-width: 24%; }
  .pf-period-5cards-row .pf-period-card-value  { font-size: 1.8rem; }
  .pf-period-5cards-row .pf-period-card-detail { font-size: 10px; }
}

.pf-period-card-value.pos { color: #c62828; }
.pf-period-card-value.neg { color: #1565c0; }
.pf-period-card-value.neu { color: #555; }

/* 소제목 + 상세금액을 한 줄로 통합 - 커진 금액 글씨와 분리되도록 여백 확대 */
.pf-period-card-detail {
  font-size: 11.5px;
  color: #888;
  margin-top: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── 툴팁 ─────────────────────────────────────────────────── */
.pf-tip-wrap {
  position: relative;
  display: inline-block;
  margin-left: 4px;
  vertical-align: middle;
}

.pf-tip-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  background: #aaa;
  color: #fff;
  border-radius: 50%;
  font-size: 9px;
  font-weight: 700;
  cursor: help;
  line-height: 1;
  flex-shrink: 0;
}

.pf-tip-icon:hover { background: #777; }

.pf-tip-box {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: #333;
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-line;
  z-index: 9999;
  min-width: 200px;
  max-width: 260px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  pointer-events: none;
  font-weight: 400;
}

/* ── 기간 평가손익 탭 하단 노트 ────────────────────────────── */
.pf-eval-note {
  margin-top: 10px;
  padding: 8px 12px;
  background: #f8f8f8;
  border-top: 1px solid #e0e0e0;
  font-size: 12px;
  color: #888;
  line-height: 1.6;
}


/* ── 드래그 분할 차트 ─────────────────────────────────────── */
.pf-split-wrap {
  display: flex;
  align-items: stretch;
  min-height: 240px;
  -webkit-user-select: none;
          user-select: none;
}

.pf-split-left {
  overflow: hidden;
  min-width: 0;
}

.pf-split-right {
  overflow: hidden;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pf-split-divider {
  width: 5px;
  background: #e8eaed;
  cursor: col-resize;
  flex-shrink: 0;
  transition: background 0.15s;
}

.pf-split-divider:hover { background: #1565c0; }


/* ── 도넛 범례 ──────────────────────────────────────────────── */
.pf-donut-legend {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 10px;
  width: 100%;
}

.pf-donut-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.pf-donut-dot {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  flex-shrink: 0;
}

.pf-donut-name { flex: 1 1; color: #555; }
.pf-donut-val  { font-weight: 600; white-space: nowrap; }
.pf-donut-val.pos { color: #c62828; }
.pf-donut-val.neg { color: #1565c0; }
.pf-donut-val.neu { color: #555; }


/* ── 공통 상태 ───────────────────────────────────────────────── */
.pf-loading {
  text-align: center;
  padding: 30px;
  color: #999;
  font-size: 13px;
}

.pf-empty {
  text-align: center;
  padding: 30px;
  color: #bbb;
  font-size: 13px;
}

.pos { color: #c62828; }
.neg { color: #1565c0; }
.neu { color: #888; }


/* ── 재집계 팝업 ─────────────────────────────────────────────── */
.pf-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pf-popup {
  background: #fff;
  border-radius: 10px;
  width: 520px;
  max-width: 96vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
}

.pf-popup-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eee;
}

.pf-popup-title { font-size: 15px; font-weight: 700; color: #1a1a1a; }

.pf-popup-close {
  background: none; border: none; cursor: pointer;
  font-size: 18px; color: #666; padding: 4px 8px; border-radius: 4px;
}

.pf-popup-close:hover { background: #eee; }

.pf-popup-bd { padding: 18px 20px; }

.pf-popup-info {
  background: #e8f0fe;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 16px;
  font-size: 12.5px;
  color: #333;
}

.pf-popup-info-row { font-weight: 600; margin-bottom: 6px; color: #1a1a1a; }

.pf-popup-ul {
  margin: 0; padding-left: 18px;
  display: flex; flex-direction: column; gap: 4px;
}

.pf-popup-field-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.pf-popup-label { font-size: 13px; font-weight: 600; color: #333; }

.pf-popup-sel {
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 13px;
}

.pf-popup-unit { font-size: 13px; color: #666; }

.pf-popup-note { font-size: 11.5px; color: #888; }

.pf-popup-msg {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
}

.pf-popup-msg.ok  { background: #e8f5e9; color: #2e7d32; }
.pf-popup-msg.err { background: #ffebee; color: #c62828; }

.pf-popup-ft {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #eee;
}

.pf-btn {
  padding: 7px 18px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
  color: #444;
}

.pf-btn:hover { background: #f5f5f5; }

.pf-btn.primary {
  background: #1565c0;
  border-color: #1565c0;
  color: #fff;
  font-weight: 600;
}

.pf-btn.primary:hover    { background: #1976d2; }
.pf-btn.primary:disabled { opacity: 0.5; cursor: default; }


/* ── 반응형 ──────────────────────────────────────────────────── */
@media (max-width: 900px) {
  .pf-cards-4           { grid-template-columns: repeat(2, 1fr); }
  .pf-period-4cards-row { flex-direction: column; }
  .pf-period-op         { display: none; }
}

@media (max-width: 600px) {
  .pf-cards-4       { grid-template-columns: 1fr 1fr; }
  .pf-split-wrap    { flex-direction: column; }
  .pf-split-left,
  .pf-split-right   { width: 100% !important; }
  .pf-split-divider { width: 100%; height: 5px; cursor: row-resize; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/status/PortfolioPage.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA,uBAAuB,kBAAkB,EAAE,mBAAmB,EAAE;AAChE,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAElG;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAErF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;;AAGpF,4DAA4D;AAC5D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,uCAAuC,mBAAmB,EAAE;AAC5D,uCAAuC,YAAY,EAAE,eAAe,EAAE;AACtE,uCAAuC,uCAAuC,EAAE;;AAEhF;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;;AAGA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA,8DAA8D;AAC9D;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;0DAC0D;AAC1D;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,WAAW,EAAE;;;AAGlC,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;;;AAGnE,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,2BAA2B,mBAAmB,EAAE;AAChD,sBAAsB,mBAAmB,EAAE;AAC3C,eAAe,iBAAiB,EAAE;AAClC,eAAe,cAAc,EAAE;AAC/B,eAAe,cAAc,EAAE;AAC/B,eAAe,WAAW,EAAE;;;AAG5B,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA,mBAAmB,mBAAmB,EAAE,kBAAkB,EAAE;AAC5D,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAE9F;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,uBAAuB,mBAAmB,EAAE,kBAAkB,EAAE;AAChE,uBAAuB,YAAY,EAAE,eAAe,EAAE;;AAEtD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB,eAAe,EAAE,WAAW,EAAE;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC,YAAY,EAAE,eAAe,EAAE;AAC/D,4CAA4C,mBAAmB,EAAE;;;AAGjE,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE;AACxE,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE;;AAExE;sCACsC;AACtC;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;kCAEkC;AAClC;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;mDACmD;AACnD;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE,+CAA+C,kBAAkB,EAAE;EACnE,+CAA+C,iBAAiB,EAAE,cAAc,EAAE;EAClF,+CAA+C,iBAAiB,EAAE;EAClE,+CAA+C,eAAe,EAAE;AAClE;;AAEA,4BAA4B,cAAc,EAAE;AAC5C,4BAA4B,cAAc,EAAE;AAC5C,4BAA4B,WAAW,EAAE;;AAEzC,gDAAgD;AAChD;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,qBAAqB,gBAAgB,EAAE;;AAEvC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;;AAGA,yDAAyD;AACzD;EACE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA,0BAA0B,mBAAmB,EAAE;;;AAG/C,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB,SAAO,EAAE,WAAW,EAAE;AACvC,iBAAiB,gBAAgB,EAAE,mBAAmB,EAAE;AACxD,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,WAAW,EAAE;;;AAGjC,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,OAAO,cAAc,EAAE;AACvB,OAAO,cAAc,EAAE;AACvB,OAAO,WAAW,EAAE;;;AAGpB,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAErE;EACE,gBAAgB,EAAE,YAAY,EAAE,eAAe;EAC/C,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB;AACpE;;AAEA,wBAAwB,gBAAgB,EAAE;;AAE1C,eAAe,kBAAkB,EAAE;;AAEnC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA,qBAAqB,gBAAgB,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAE3E;EACE,SAAS,EAAE,kBAAkB;EAC7B,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAElE;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB,eAAe,EAAE,WAAW,EAAE;;AAE/C,iBAAiB,iBAAiB,EAAE,WAAW,EAAE;;AAEjD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB,mBAAmB,EAAE;;AAErC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B,mBAAmB,EAAE;AAChD,2BAA2B,YAAY,EAAE,eAAe,EAAE;;;AAG1D,gEAAgE;AAChE;EACE,wBAAwB,qCAAqC,EAAE;EAC/D,wBAAwB,sBAAsB,EAAE;EAChD,wBAAwB,aAAa,EAAE;AACzC;;AAEA;EACE,oBAAoB,8BAA8B,EAAE;EACpD,oBAAoB,sBAAsB,EAAE;EAC5C;sBACoB,sBAAsB,EAAE;EAC5C,oBAAoB,WAAW,EAAE,WAAW,EAAE,kBAAkB,EAAE;AACpE","sourcesContent":["/* PortfolioPage CSS */\n\n/* ── 자동 재집계 배너 ─────────────────────────────────────── */\n.pf-reclose-banner {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.pf-reclose-banner.checking {\n  background: #e3f2fd;\n  color: #1565c0;\n  border: 1px solid #90caf9;\n}\n\n.pf-reclose-banner.done {\n  background: #e8f5e9;\n  color: #2e7d32;\n  border: 1px solid #a5d6a7;\n}\n\n/* ── 전체 레이아웃 ─────────────────────────────────────────── */\n.pf-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #e8eaed;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.pf-acct-btns {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  flex: 1;\n}\n\n.pf-acct-btn {\n  padding: 5px 14px;\n  border: 1px solid #d0d5dd;\n  border-radius: 20px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 13px;\n  color: #444;\n  transition: all 0.15s;\n}\n\n.pf-acct-btn:hover   { border-color: #aaa; background: #f5f5f5; }\n.pf-acct-btn.active  { background: #1565c0; border-color: #1565c0; color: #fff; font-weight: 600; }\n\n.pf-diagnose-btn {\n  padding: 5px 12px;\n  background: #fff;\n  border: 1px solid #bbb;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #555;\n  white-space: nowrap;\n}\n\n.pf-diagnose-btn:hover { background: #fff8e1; border-color: #f57c00; color: #e65100; }\n\n.pf-reclose-btn {\n  padding: 5px 14px;\n  background: #fff;\n  border: 1px solid #bbb;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #555;\n  white-space: nowrap;\n}\n\n.pf-reclose-btn:hover { background: #f0f4f8; border-color: #1565c0; color: #1565c0; }\n\n\n/* ── 새로고침 버튼 ──────────────────────────────────────────── */\n.pf-refresh-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #2e7d32;\n  border: none;\n  color: #fff;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 0.15s;\n  line-height: 1;\n}\n\n.pf-refresh-btn:hover:not(:disabled) { background: #388e3c; }\n.pf-refresh-btn:disabled             { opacity: 0.6; cursor: default; }\n.pf-refresh-btn.spinning             { animation: pf-spin 0.8s linear infinite; }\n\n@keyframes pf-spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n\n/* ── 섹션 ──────────────────────────────────────────────────── */\n.pf-section {\n  background: #fff;\n  border: 1px solid #e8eaed;\n  border-radius: 10px;\n  padding: 10px 14px;\n  margin-bottom: 8px;\n}\n\n.pf-section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.pf-section-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  background: #1565c0;\n  color: #fff;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.pf-section-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n.pf-temp-badge {\n  font-size: 11px;\n  color: #e65100;\n  background: #fff3e0;\n  border: 1px solid #ffcc80;\n  border-radius: 12px;\n  padding: 2px 8px;\n}\n\n\n/* ── 4카드 (Section ①) ────────────────────────────────────── */\n.pf-cards-4 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.pf-card {\n  background: #f8f9fc;\n  border: 1px solid #e5e9f0;\n  border-radius: 8px;\n  padding: 16px 18px;\n  min-width: 0;\n}\n\n/* 라벨(좌측, 작게) + 큰 숫자(그 뒤, 카드 중간 지점 부근부터).\n   금액 font-size가 커진 만큼 라벨 예약폭은 46%→36%로 줄여 금액이 잘리지 않도록 함 */\n.pf-card-top {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.pf-card-label {\n  font-size: 11.5px;\n  color: #666;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n  min-width: 36%;\n}\n\n.pf-card-value {\n  flex: 1;\n  min-width: 0;\n  font-size: 2.6rem;\n  font-weight: 700;\n  color: #1a1a1a;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n}\n\n/* 소제목 + 상세금액을 한 줄로 통합 - 커진 금액 글씨와 분리되도록 여백 확대 */\n.pf-card-detail {\n  font-size: 11.5px;\n  color: #888;\n  margin-top: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pf-card-value.pos { color: #c62828; }\n.pf-card-value.neg { color: #1565c0; }\n.pf-card-value.neu { color: #555; }\n\n\n/* ── 보유 종목 헤더 ─────────────────────────────────────────── */\n.pf-holdings-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.pf-sub-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.pf-detail-btn {\n  padding: 5px 14px;\n  background: #f0f4ff;\n  border: 1px solid #b3c8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #1565c0;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.pf-detail-btn:hover { background: #e0ecff; border-color: #1565c0; }\n\n\n/* ── 보유 종목 테이블 ────────────────────────────────────────── */\n.pf-tbl-wrap {\n  overflow-x: auto;\n  border-radius: 6px;\n  border: 1px solid #e5e9f0;\n}\n\n.pf-tbl {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n}\n\n.pf-tbl th {\n  background: #f0f2f6;\n  padding: 8px 10px;\n  text-align: center;\n  font-weight: 600;\n  color: #444;\n  border-bottom: 2px solid #d6dae6;\n  white-space: nowrap;\n}\n\n.pf-tbl td {\n  padding: 7px 10px;\n  border-bottom: 1px solid #f0f2f5;\n  white-space: nowrap;\n}\n\n.pf-tbl tr:last-child td { border-bottom: none; }\n.pf-tbl tr:hover td { background: #fafbfe; }\n.pf-tbl .num { text-align: right; }\n.pf-tbl .pos { color: #c62828; }\n.pf-tbl .neg { color: #1565c0; }\n.pf-tbl .neu { color: #888; }\n\n\n/* ── 기간 선택 바 ────────────────────────────────────────────── */\n.pf-period-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 7px 12px;\n  background: #fff;\n  border: 1px solid #e8eaed;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.pf-period-btns {\n  display: flex;\n  gap: 4px;\n}\n\n.pf-p-btn {\n  padding: 6px 16px;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 13px;\n  color: #444;\n  transition: all 0.15s;\n}\n\n.pf-p-btn:hover  { background: #f5f5f5; border-color: #aaa; }\n.pf-p-btn.active { background: #1565c0; border-color: #1565c0; color: #fff; font-weight: 600; }\n\n.pf-nav-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pf-nav-btn {\n  width: 30px;\n  height: 30px;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n}\n\n.pf-nav-btn:hover    { background: #f0f4f8; border-color: #aaa; }\n.pf-nav-btn:disabled { opacity: 0.4; cursor: default; }\n\n.pf-nav-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a1a;\n  min-width: 110px;\n  text-align: center;\n}\n\n.pf-custom-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pf-custom-sel {\n  padding: 5px 10px;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #333;\n  background: #fff;\n  cursor: pointer;\n}\n\n.pf-custom-tilde { font-size: 14px; color: #666; }\n\n.pf-custom-query-btn {\n  padding: 6px 16px;\n  background: #1565c0;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pf-custom-query-btn:disabled { opacity: 0.5; cursor: default; }\n.pf-custom-query-btn:hover:not(:disabled) { background: #1976d2; }\n\n\n/* ── Section ② 기간 손익 ──────────────────────────────────── */\n.pf-period-4cards-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.pf-period-op {\n  font-size: 1.4rem;\n  color: #555;\n  font-weight: 300;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.pf-period-card {\n  flex: 1;\n  background: #f8f9fc;\n  border: 1px solid #e5e9f0;\n  border-radius: 8px;\n  padding: 16px 18px;\n  min-width: 0;\n}\n\n.pf-period-card-total {\n  background: #e8f0fe;\n  border-color: #b8cef8;\n}\n\n.pf-period-card-total.pos { background: #fff0f0; border-color: #f5b8b8; }\n.pf-period-card-total.neg { background: #f0f4ff; border-color: #b8c8f8; }\n\n/* 매매손익(중간 합계) - 최종 합계(pf-period-card-total)보다는 약하게,\n   그냥 카드(pf-period-card)보다는 눈에 띄게 구분 */\n.pf-period-card-subtotal {\n  background: #f3f5fa;\n  border: 1.5px dashed #c3cce0;\n}\n\n/* 라벨(좌측, 작게) + 큰 숫자(그 뒤, 카드 중간 지점 부근부터).\n   5개 카드가 +/= 기호와 한 줄을 나눠 쓰는 만큼 pf-card보다 폭이 좁아서\n   라벨 예약폭을 줄여 커진 금액 글씨가 잘리지 않게 함 */\n.pf-period-card-top {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.pf-period-card-label {\n  font-size: 11.5px;\n  color: #666;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n  min-width: 32%;\n}\n\n.pf-period-card-value {\n  flex: 1;\n  min-width: 0;\n  font-size: 2.6rem;\n  font-weight: 700;\n  color: #1a1a1a;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n}\n\n/* 5카드(②기간별 손익)는 4카드보다 한 장 더 들어가 폭이 좁아지므로\n   패딩/라벨폭/글씨크기를 줄여 1920px에서 줄바꿈·잘림 없이 한 줄에 들어오게 함 */\n.pf-period-5cards-row {\n  gap: 5px;\n}\n\n.pf-period-5cards-row .pf-period-op {\n  font-size: 1.2rem;\n}\n\n.pf-period-5cards-row .pf-period-card {\n  padding: 14px 12px;\n}\n\n.pf-period-5cards-row .pf-period-card-label {\n  min-width: 26%;\n}\n\n.pf-period-5cards-row .pf-period-card-value {\n  font-size: 2.2rem;\n}\n\n/* 노트북 등 좁은 화면(1600px 이하)에서는 한 번 더 줄여 잘림 방지 */\n@media (max-width: 1600px) {\n  .pf-period-5cards-row .pf-period-card        { padding: 12px 10px; }\n  .pf-period-5cards-row .pf-period-card-label  { font-size: 10.5px; min-width: 24%; }\n  .pf-period-5cards-row .pf-period-card-value  { font-size: 1.8rem; }\n  .pf-period-5cards-row .pf-period-card-detail { font-size: 10px; }\n}\n\n.pf-period-card-value.pos { color: #c62828; }\n.pf-period-card-value.neg { color: #1565c0; }\n.pf-period-card-value.neu { color: #555; }\n\n/* 소제목 + 상세금액을 한 줄로 통합 - 커진 금액 글씨와 분리되도록 여백 확대 */\n.pf-period-card-detail {\n  font-size: 11.5px;\n  color: #888;\n  margin-top: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── 툴팁 ─────────────────────────────────────────────────── */\n.pf-tip-wrap {\n  position: relative;\n  display: inline-block;\n  margin-left: 4px;\n  vertical-align: middle;\n}\n\n.pf-tip-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  background: #aaa;\n  color: #fff;\n  border-radius: 50%;\n  font-size: 9px;\n  font-weight: 700;\n  cursor: help;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.pf-tip-icon:hover { background: #777; }\n\n.pf-tip-box {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  background: #333;\n  color: #fff;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  line-height: 1.6;\n  white-space: pre-line;\n  z-index: 9999;\n  min-width: 200px;\n  max-width: 260px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.3);\n  pointer-events: none;\n  font-weight: 400;\n}\n\n/* ── 기간 평가손익 탭 하단 노트 ────────────────────────────── */\n.pf-eval-note {\n  margin-top: 10px;\n  padding: 8px 12px;\n  background: #f8f8f8;\n  border-top: 1px solid #e0e0e0;\n  font-size: 12px;\n  color: #888;\n  line-height: 1.6;\n}\n\n\n/* ── 드래그 분할 차트 ─────────────────────────────────────── */\n.pf-split-wrap {\n  display: flex;\n  align-items: stretch;\n  min-height: 240px;\n  user-select: none;\n}\n\n.pf-split-left {\n  overflow: hidden;\n  min-width: 0;\n}\n\n.pf-split-right {\n  overflow: hidden;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.pf-split-divider {\n  width: 5px;\n  background: #e8eaed;\n  cursor: col-resize;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n\n.pf-split-divider:hover { background: #1565c0; }\n\n\n/* ── 도넛 범례 ──────────────────────────────────────────────── */\n.pf-donut-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 2px 10px;\n  width: 100%;\n}\n\n.pf-donut-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.pf-donut-dot {\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.pf-donut-name { flex: 1; color: #555; }\n.pf-donut-val  { font-weight: 600; white-space: nowrap; }\n.pf-donut-val.pos { color: #c62828; }\n.pf-donut-val.neg { color: #1565c0; }\n.pf-donut-val.neu { color: #555; }\n\n\n/* ── 공통 상태 ───────────────────────────────────────────────── */\n.pf-loading {\n  text-align: center;\n  padding: 30px;\n  color: #999;\n  font-size: 13px;\n}\n\n.pf-empty {\n  text-align: center;\n  padding: 30px;\n  color: #bbb;\n  font-size: 13px;\n}\n\n.pos { color: #c62828; }\n.neg { color: #1565c0; }\n.neu { color: #888; }\n\n\n/* ── 재집계 팝업 ─────────────────────────────────────────────── */\n.pf-popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.4);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pf-popup {\n  background: #fff;\n  border-radius: 10px;\n  width: 520px;\n  max-width: 96vw;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n}\n\n.pf-popup-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.pf-popup-title { font-size: 15px; font-weight: 700; color: #1a1a1a; }\n\n.pf-popup-close {\n  background: none; border: none; cursor: pointer;\n  font-size: 18px; color: #666; padding: 4px 8px; border-radius: 4px;\n}\n\n.pf-popup-close:hover { background: #eee; }\n\n.pf-popup-bd { padding: 18px 20px; }\n\n.pf-popup-info {\n  background: #e8f0fe;\n  border-radius: 6px;\n  padding: 12px 14px;\n  margin-bottom: 16px;\n  font-size: 12.5px;\n  color: #333;\n}\n\n.pf-popup-info-row { font-weight: 600; margin-bottom: 6px; color: #1a1a1a; }\n\n.pf-popup-ul {\n  margin: 0; padding-left: 18px;\n  display: flex; flex-direction: column; gap: 4px;\n}\n\n.pf-popup-field-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.pf-popup-label { font-size: 13px; font-weight: 600; color: #333; }\n\n.pf-popup-sel {\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.pf-popup-unit { font-size: 13px; color: #666; }\n\n.pf-popup-note { font-size: 11.5px; color: #888; }\n\n.pf-popup-msg {\n  margin-top: 10px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.pf-popup-msg.ok  { background: #e8f5e9; color: #2e7d32; }\n.pf-popup-msg.err { background: #ffebee; color: #c62828; }\n\n.pf-popup-ft {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 20px;\n  border-top: 1px solid #eee;\n}\n\n.pf-btn {\n  padding: 7px 18px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 13px;\n  color: #444;\n}\n\n.pf-btn:hover { background: #f5f5f5; }\n\n.pf-btn.primary {\n  background: #1565c0;\n  border-color: #1565c0;\n  color: #fff;\n  font-weight: 600;\n}\n\n.pf-btn.primary:hover    { background: #1976d2; }\n.pf-btn.primary:disabled { opacity: 0.5; cursor: default; }\n\n\n/* ── 반응형 ──────────────────────────────────────────────────── */\n@media (max-width: 900px) {\n  .pf-cards-4           { grid-template-columns: repeat(2, 1fr); }\n  .pf-period-4cards-row { flex-direction: column; }\n  .pf-period-op         { display: none; }\n}\n\n@media (max-width: 600px) {\n  .pf-cards-4       { grid-template-columns: 1fr 1fr; }\n  .pf-split-wrap    { flex-direction: column; }\n  .pf-split-left,\n  .pf-split-right   { width: 100% !important; }\n  .pf-split-divider { width: 100%; height: 5px; cursor: row-resize; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
